<template>
  <header class="c-header w-100 pb-0">
    <div class="container position-relative">
      <nav class="c-nav w-100">
        <div class="c-nav__left d-flex justify-content-center align-items-center">
          <figure
            v-if="general.data"
            class="c-brand c-brand--normal d-flex justify-content-center align-items-center">
            <router-link class="c-brand__link" to="/">
              <img
                class="c-brand__image"
                :src="general.data.information.brand"
                alt="Panda WP - Logo"
              />
            </router-link>
          </figure>
        </div>
        <div class="c-nav__right">
          <ul class="c-menu menu ul-reset d-none">
            <li>
              <router-link to="" class="position-relative" replace>
                a
              </router-link>
            </li>
            <li>
              <router-link to="" class="position-relative" replace>
                b
              </router-link>
            </li>
          </ul>
          <div class="d-flex">
            <div class="align-items-center d-none d-lg-flex">
              <a href="#proyecto" class="c-header__link me-3">
                Proyecto
              </a>
              <a href="#ubicacion" class="c-header__link me-3">
                Ubicación
              </a>
              <a href="#galeria" class="c-header__link me-3">
                Galería
              </a>
              <a href="#tipologia" class="c-header__link me-3">
                Tipología
              </a>
              <a href="" class="c-header__link">
                Web Principal
              </a>
            </div>
            <a
              v-if="!wspButtonEnable"
              :href="wspContact"
              class="c-button c-button--success py-1 ms-5">
              <span class="fs-25 me-1">
                <Icon icon="ic:baseline-whatsapp"/>
              </span>
              Contactar Ahora
            </a>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['general']),

    wspButtonEnable() {
      return this.general.data.information?.message_whatsapp_enable;
    },

    wspContact() {
      return (this.general.data.information)
        ? `https://api.whatsapp.com/send?phone=${this.general.data.information.phone}&text=${this.general.data.information.message_whatsapp}`
        : '';
    },
  },
  methods: {
  },
};
</script>
